import { useCallback, useEffect, useState } from 'react'

import { useScreen } from '@/store/screen'

export const useHero = (typewriterWords: string[]) => {
  const { isBiggerMobile, isSmallDesktop, isTablet } = useScreen()
  const [availableWords, setAvailableWords] =
    useState<string[]>(typewriterWords)

  const getHeadingSize = useCallback(() => {
    if (isBiggerMobile) return 'h5'
    if (isSmallDesktop) return 'h3'
    if (isTablet) return 'h2'
    return 'h2'
  }, [isBiggerMobile, isSmallDesktop, isTablet])

  useEffect(() => {
    if (isBiggerMobile) {
      return setAvailableWords(
        typewriterWords.filter((word) => word !== 'produtos digitais'),
      )
    }
    return setAvailableWords(typewriterWords)
  }, [isBiggerMobile, typewriterWords])

  return {
    getHeadingSize,
    availableWords,
  }
}
